import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Pagination } from 'hljd'
import style from './style.module.less'
import { getMoney } from '@hlj/hlj-utils'
import Store from './store'
import { isStoreAccount } from '@util'

const TabItem = ({ active, title, type, onClick }) => (
  <li style={{ background: active ? '#fff' : '#f4f5fa' }}>
    <a onClick={e => onClick(type)}>{title}</a>
  </li>
)
@inject('mainStore')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store(props.mainStore)
  }
  componentDidMount() {
    this.store.init()
    this.store.setTabList()
  }
  render() {
    const {
      tablist,
      // selectList,
      activeTab,
      handleChangeTab,
      checkedValue,
      handleCheckItem,
      conList,
      caseList,
      paginationTest,
      paginationCase,
      onConChange,
      onCaseChange,
      handleOk,
      handleCancel
    } = this.store

    return (
      <div className={style.box}>
        <div className={style.modalBox}>
          <ul className={style.tabHead}>
            {tablist.map(({ type, title }, i) => (
              <TabItem
                key={i}
                active={type === activeTab}
                title={title}
                type={type}
                onClick={handleChangeTab}
              />
            ))}
          </ul>
          <div className={style.tabContent}>
            {/* 套餐 */}
            {activeTab === 'meal' && (
              <div>
                <div className={style.con}>
                  {conList.map(item => (
                    <div className={style.conBox} key={item.id}>
                      <dl>
                        <dt>
                          <img
                            src={item.cover_path + '?imageView2/1/w/156/h/99'}
                          />
                        </dt>
                        <dd>
                          <h3>{item.title}</h3>
                          <p>
                            <em>{getMoney(item.actual_price)}</em>
                            <i>{getMoney(item.market_price)}</i>
                          </p>
                        </dd>
                      </dl>
                      <img
                        onClick={() =>
                          handleCheckItem(true, 'meal', item.id, item)
                        }
                        style={{
                          display:
                            checkedValue.type === 'meal' &&
                            item.id == checkedValue.id
                              ? 'none'
                              : 'inline-block'
                        }}
                        className={style.isCheck}
                        src="http://qnm.hunliji.com/o_1b2ssujbl18jc3il161618oc1aju7.png"
                      />
                      <img
                        onClick={e =>
                          handleCheckItem(false, 'meal', item.id, item)
                        }
                        style={{
                          display:
                            checkedValue.type === 'meal' &&
                            item.id == checkedValue.id
                              ? 'inline-block'
                              : 'none'
                        }}
                        className={style.isCheck}
                        src="http://qnm.hunliji.com/o_1b2ssv00d1uvm1pnkm9l5a717tpc.png"
                      />
                    </div>
                  ))}
                </div>
                <div className={style.paginationTest}>
                  <Pagination
                    size="small"
                    current={paginationTest.current}
                    onChange={onConChange}
                    pageSize={6}
                    total={paginationTest.total}
                  />
                </div>
              </div>
            )}
            {/* 案例 */}
            {activeTab === 'case' && (
              <div>
                <div className={style.con}>
                  {caseList.map(item => (
                    <div className={style.conBox} key={item.id}>
                      <dl>
                        <dt>
                          <img
                            src={item.cover_path + '?imageView2/1/w/156/h/99'}
                          />
                        </dt>
                        <dd>
                          <h3>{item.title}</h3>
                        </dd>
                      </dl>
                      <img
                        onClick={() =>
                          handleCheckItem(true, 'case', item.id, item)
                        }
                        style={{
                          display:
                            checkedValue.type === 'case' &&
                            item.id == checkedValue.id
                              ? 'none'
                              : 'inline-block'
                        }}
                        className={style.isCheck}
                        src="http://qnm.hunliji.com/o_1b2ssujbl18jc3il161618oc1aju7.png"
                      />
                      <img
                        onClick={e =>
                          handleCheckItem(false, 'meal', item.id, item)
                        }
                        style={{
                          display:
                            checkedValue.type === 'case' &&
                            item.id == checkedValue.id
                              ? 'inline-block'
                              : 'none'
                        }}
                        className={style.isCheck}
                        src="http://qnm.hunliji.com/o_1b2ssv00d1uvm1pnkm9l5a717tpc.png"
                      />
                    </div>
                  ))}
                </div>
                <div className={style.paginationTest}>
                  <Pagination
                    size="small"
                    current={paginationCase.current}
                    onChange={onCaseChange}
                    pageSize={6}
                    total={paginationCase.total}
                  />
                </div>
              </div>
            )}
            {activeTab === 'mealList' && (
              <div>
                <div className={style.talkBox}>
                  <dl>
                    <dt>
                      <img src="//qnm.hunliji.com/o_1cnllmknv1t2i1glij0ihjm4jl9.png" />
                    </dt>
                    <dd>
                      <h3>{isStoreAccount() ? '新商品管理' : '套餐列表页'}</h3>
                    </dd>
                  </dl>
                  <img
                    onClick={() =>
                      handleCheckItem(true, activeTab, '1', { type: activeTab })
                    }
                    style={{
                      display:
                        checkedValue.type === 'mealList'
                          ? 'none'
                          : 'inline-block'
                    }}
                    className={style.isCheck}
                    src="http://qnm.hunliji.com/o_1b2ssujbl18jc3il161618oc1aju7.png"
                  />
                  <img
                    onClick={() =>
                      handleCheckItem(true, activeTab, '0', { type: activeTab })
                    }
                    style={{
                      display:
                        checkedValue.type === 'mealList'
                          ? 'inline-block'
                          : 'none'
                    }}
                    className={style.isCheck}
                    src="http://qnm.hunliji.com/o_1b2ssv00d1uvm1pnkm9l5a717tpc.png"
                  />
                </div>
              </div>
            )}
            {activeTab === 'talk' && (
              <div>
                <div className={style.talkBox}>
                  <dl>
                    <dt>
                      <img src="http://qnm.hunliji.com/o_1bftna5o81af94rgrl9iq6jsec.png" />
                    </dt>
                    <dd>
                      <h3>私信咨询</h3>
                    </dd>
                  </dl>
                  <img
                    onClick={() =>
                      handleCheckItem(true, activeTab, '1', { type: activeTab })
                    }
                    style={{
                      display:
                        checkedValue.type === 'talk' ? 'none' : 'inline-block'
                    }}
                    className={style.isCheck}
                    src="http://qnm.hunliji.com/o_1b2ssujbl18jc3il161618oc1aju7.png"
                  />
                  <img
                    onClick={() =>
                      handleCheckItem(false, activeTab, '0', {
                        type: activeTab
                      })
                    }
                    style={{
                      display:
                        checkedValue.type === 'talk' ? 'inline-block' : 'none'
                    }}
                    className={style.isCheck}
                    src="http://qnm.hunliji.com/o_1b2ssv00d1uvm1pnkm9l5a717tpc.png"
                  />
                </div>
              </div>
            )}

            <p className={style.btnBottom}>
              <a onClick={handleOk}>确定</a>
              <a onClick={handleCancel}>取消</a>
            </p>
          </div>
        </div>
      </div>
    )
  }
}
